module.exports = __webpack_public_path__ + "static/media/stats-icon-2.c974d70b.svg";